// Apiservices/Auth/servers/tentPackageApi.js
import axiosInstance from "../../../util/axiosInstance";

export const tentPackageApi = {
  // Get all packages
  getPackages: async () => {
    try {
      const response = await axiosInstance.get('v1/tent-house/package/');
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
  
  // Get package by ID
  getPackageById: async (id) => {
    try {
      const response = await axiosInstance.get(`v1/tent-house/package/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
  
  // Create package
  createPackage: async (data) => {
    try {
      const response = await axiosInstance.post('v1/tent-house/package', data);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
  
  // Update package
  updatePackage: async (id, data) => {
    try {
      const response = await axiosInstance.put(`v1/tent-house/package/${id}`, data);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
  
  // Delete package
  deletePackage: async (id) => {
    try {
      const response = await axiosInstance.delete(`v1/tent-house/package/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
};

// Simple error handling utility function
const handleApiError = (error) => {
  if (error.response) {
    // Server responded with error status
    throw new Error(error.response.data?.message || error.response.data?.error || 'Request failed');
  } else if (error.request) {
    // Request made but no response received
    throw new Error('Network error. Please check your connection.');
  } else {
    // Something happened in setting up the request
    throw new Error(error.message || 'Request error');
  }
};